export enum SENTRY_FEATURE {
  TAGS = 'tags',
  SHIFT = 'shift',
  GEOFENCE = 'geofence',
  DASHBOARD = 'dashboard',
  ORDER_WELL = 'order-well',
  BOL_REPORT = 'bol-report',
  DIVERGENCE_REPORT = 'divergence-report',
  MOVE_ASSET = 'move-asset',
  SHIFT_BOARD = 'shift-board',
  BULK_DELETE = 'bulk-delete',
  BULK_UNBLOCK = 'bulk-unblock',
  DRIVER_RATE = 'driver-rate',
  CONTEXT_MENU = 'context-menu',
  LOADING_ORDER = 'loading-order',
  TRANSFER_ORDER = 'transfer-order',
  TRANSFER_ASSET = 'transfer-asset',
  DELIVERY_ORDER = 'delivery-order',
  CUSTOMER_TABLE = 'customer-table',
  CUSTOMER_PORTAL = 'customer-portal',
  RECURRING_ORDER = 'recurring-order',
  GENERATE_REPORT = 'generate-report',
  ASSET_INVENTORY = 'asset-inventory',
  FETCH_TAX_REPORT = 'fetch-tax-report',
  DRIVER_DEMURRAGE = 'driver-demurrage',
  LINK_ORDER_SHIFT = 'link-order-shift',
  BULK_EDIT_ASSIGN = 'bulk-edit-assign',
  CREATE_ORDER_BETA = 'create-order-beta',
  LOAD_ORDER_DETAILS = 'load-order-details',
  FETCH_SALES_REPORT = 'fetch-sales-report',
  PUBLIC_ORDER_DETAIL = 'public-order-detail',
  BULK_PLANT_INVENTORY = 'bulk-plant-inventory',
  CUSTOMER_PREFERENCES = 'customer-preferences',
  ORDER_WELL_SAVE_VIEWS = 'order-well-save-views',
  DELIVERY_ORDER_DETAIL = 'delivery-order-detail',
  CSV_TEMPLATE_ENTITIES = 'csv-template-entities',
  EXTRACTION_ORDER_DETAIL = 'extraction-order-detail',
  CUSTOMER_PRICING_ORDER_QUOTE = 'customer-pricing-order-quote',
  DEGREE_DAYS = 'degree-days',
}
